import {isFeatureEnabled} from 'feature-flags';

import {featureFlags} from '@dms/feature-flags';

import {isAlphaFilterableSuspiciousReason} from '../../../constants/sourcingSuspiciousReasons';
import {FiltersType} from '../types/FiltersType';
import {isSuspiciousReasonFilterEnabled} from './isSuspiciousReasonFilterEnabled';

export function createSourcingAdState(filters: FiltersType) {
  const excludedReasons =
    isSuspiciousReasonFilterEnabled() && !filters.hideSuspicious
      ? filters.excludeSuspiciousReasons?.filter(isAlphaFilterableSuspiciousReason)
      : undefined;

  return {
    includeSuspicious:
      !isFeatureEnabled(featureFlags.SOURCING_SUSPICIOUS_VEHICLES) || !filters.hideSuspicious,
    excludeSuspiciousReasons: excludedReasons?.length ? excludedReasons : undefined,
    onlyHitlist: filters.hitlistOnly ?? undefined,
    includeBlacklist: !filters.hideBlacklist,
  };
}
